export default __webpack_public_path__ + "static/media/chicken-thighs.412420cd.jpg";